module.exports = __webpack_public_path__ + "img/oneDesGreen.5106c9f3.jpg";